"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es7.string.pad-start");

require("core-js/modules/es6.string.ends-with");

require("core-js/modules/es6.string.starts-with");

require("core-js/modules/es6.set");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.string.iterator");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));

require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.array.find");

require("core-js/modules/web.dom.iterable");

var _toConsumableArray2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/toConsumableArray.js"));

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

var _order = require("@/api/cms/order");

var _send = require("@/api/cms/send");

var _installTask = require("@/api/cms/installTask");

var _contract2 = require("@/api/cms/contract");

var _cmsWorkOrder = require("@/api/cmsWorkOrder");

var _commonUpload = _interopRequireDefault(require("@/views/cms/common/commonUpload"));

var _userSelect = _interopRequireDefault(require("@/views/cms/common/userSelect"));

var _index = _interopRequireDefault(require("./orderDetail/index"));

var _index2 = _interopRequireDefault(require("@/views/cms/customers/contractQuotationInfo/index"));

var _index3 = _interopRequireDefault(require("@/views/cms/customers/contractBasicInfo/index"));

var _index4 = _interopRequireDefault(require("@/views/cms/customers/contractDesignInfo/index"));

var _index5 = _interopRequireDefault(require("@/views/cms/customers/contractFollowInfo/index"));

var _index6 = _interopRequireDefault(require("@/views/cms/customers/contractSpecialApply/index"));

var _index7 = _interopRequireDefault(require("@/views/cms/customers/contractProductionTracking/index"));

var _index8 = _interopRequireDefault(require("@/views/cms/customers/contractAfterInfo/index"));

var _Dict = _interopRequireDefault(require("@/components/Dict/Dict"));

var _vuedraggable = _interopRequireDefault(require("vuedraggable"));

var _dictDetail = require("@/api/system/dictDetail");

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }

function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }

function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }

var _default = {
  name: 'OrderList',
  components: {
    CommonUpload: _commonUpload.default,
    UserSelect: _userSelect.default,
    OrderDetail: _index.default,
    ContractQuotationInfo: _index2.default,
    ContractBasicInfo: _index3.default,
    ContractDesignInfo: _index4.default,
    ContractFollowInfo: _index5.default,
    ContractSpecialApply: _index6.default,
    ContractProductionTracking: _index7.default,
    ContractAfterInfo: _index8.default,
    draggable: _vuedraggable.default
  },
  dicts: ['order_status_button', 'order_display_fields', 'order_payment_reason', 'order_receiving_account', 'contract_status_button'],
  created: function created() {
    var _this = this;

    this.$on('dictReady', function () {
      _this.initTableHeader();
    });
    var filter = this.$route.query.filter;

    if (filter) {
      this.selectedStatus = filter;
      this.searchForm.productionStatus = filter;
    }

    var contractStatus = this.$route.query.contractStatus;

    if (contractStatus) {
      this.searchForm.contractStatus = contractStatus;
    }
  },
  computed: {
    tableHeight: function tableHeight() {
      return this.screenHeight * (this.showMoreSearch ? 0.46 : 0.55);
    },
    filteredBomList: function filteredBomList() {
      this.bomSearchVersion;
      var _this$addOrderForm = this.addOrderForm,
          searchCode = _this$addOrderForm.searchCode,
          searchName = _this$addOrderForm.searchName,
          searchColor = _this$addOrderForm.searchColor,
          searchBarCode = _this$addOrderForm.searchBarCode,
          searchMaterialTypeInfo = _this$addOrderForm.searchMaterialTypeInfo,
          searchLength = _this$addOrderForm.searchLength,
          searchWidth = _this$addOrderForm.searchWidth,
          searchHeight = _this$addOrderForm.searchHeight,
          searchQuantity = _this$addOrderForm.searchQuantity,
          searchRemark = _this$addOrderForm.searchRemark,
          bomList = _this$addOrderForm.bomList;
      var code = searchCode ? searchCode.trim() : '';
      var name = searchName ? searchName.trim() : '';
      var color = searchColor ? searchColor.trim() : '';
      var barCode = searchBarCode ? searchBarCode.trim() : '';
      var materialTypeInfo = searchMaterialTypeInfo ? searchMaterialTypeInfo.trim() : '';
      var length = searchLength ? searchLength.trim() : '';
      var width = searchWidth ? searchWidth.trim() : '';
      var height = searchHeight ? searchHeight.trim() : '';
      var quantity = searchQuantity ? searchQuantity.trim() : '';
      var remark = searchRemark ? searchRemark.trim() : '';

      if (!code && !name && !color && !barCode && !materialTypeInfo && !length && !width && !height && !quantity && !remark) {
        return bomList;
      }

      return bomList.filter(function (bom) {
        var matchCode = !code || bom.Code && bom.Code.toLowerCase().includes(code.toLowerCase());
        var matchName = !name || bom.Name && bom.Name.toLowerCase().includes(name.toLowerCase());
        var matchColor = !color || bom.Color && bom.Color.toLowerCase().includes(color.toLowerCase());
        var matchBarCode = !barCode || bom.BarCode && bom.BarCode.toLowerCase().includes(barCode.toLowerCase());
        var matchMaterialTypeInfo = !materialTypeInfo || bom.MaterialTypeInfo && bom.MaterialTypeInfo.toLowerCase().includes(materialTypeInfo.toLowerCase());
        var matchLength = !length || bom.Length !== undefined && String(bom.Length).toLowerCase().includes(length.toLowerCase());
        var matchWidth = !width || bom.Width !== undefined && String(bom.Width).toLowerCase().includes(width.toLowerCase());
        var matchHeight = !height || bom.Height !== undefined && String(bom.Height).toLowerCase().includes(height.toLowerCase());
        var matchQuantity = !quantity || bom.Quantity !== undefined && String(bom.Quantity).toLowerCase().includes(quantity.toLowerCase());
        var matchRemark = !remark || bom.Remark && bom.Remark.toLowerCase().includes(remark.toLowerCase());
        return matchCode && matchName && matchColor && matchBarCode && matchMaterialTypeInfo && matchLength && matchWidth && matchHeight && matchQuantity && matchRemark;
      });
    },
    visibleColumns: {
      get: function get() {
        return this.tableHeader.filter(function (col) {
          return col.visible;
        });
      },
      set: function set(val) {
        this.tableHeader = [].concat((0, _toConsumableArray2.default)(val), (0, _toConsumableArray2.default)(this.tableHeader.filter(function (col) {
          return !col.visible;
        })));
      }
    }
  },
  watch: {
    $route: function $route(to, from) {
      var filter = to.query.filter;

      if (filter) {
        this.selectedStatus = filter;
        this.searchForm.productionStatus = filter;
      } else {
        this.selectedStatus = '全部';
        this.searchForm.productionStatus = '';
      }

      var contractStatus = to.query.contractStatus;

      if (contractStatus) {
        this.searchForm.contractStatus = contractStatus;
      } else {
        this.searchForm.contractStatus = '';
      }

      this.handleSearch();
    },
    tableHeader: {
      handler: function handler() {
        this.$forceUpdate();
      },
      deep: true
    },
    'searchForm.productionStatus': function searchFormProductionStatus(val) {
      this.selectedStatus = val || '全部';
    }
  },
  mounted: function mounted() {
    //加载状态按钮
    this.getStatusCounts(); //加载搜索表单

    this.handleSearch(); //加载表头配置

    this.loadHeaderConfig(); //监听屏幕高度变化

    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  data: function data() {
    return {
      searchLoading: false,
      showMoreSearch: false,
      bomTableLoading: false,
      bomSearchVersion: 0,
      screenHeight: document.documentElement.clientHeight || document.body.clientHeight,
      collapsedOrders: [],
      collapsedContracts: [],
      isAllExpanded: false,
      activeQuotationTab: 'quotation',
      showQuotationDialog: false,
      currentQuotationContract: {},
      // 合同详情相关
      showContractViewDialog: false,
      currentContract: {},
      contractViewImages: [],
      contractViewFiles: [],
      activeContractTab: 'design',
      previewImageVisible: false,
      previewImageUrl: '',
      // 合同图片附件预览相关
      previewVisible: false,
      previewImages: [],
      previewFilesVisible: false,
      previewFiles: [],
      contractEditable: false,
      // 表头配置相关
      tableHeader: [],
      configDialogVisible: false,
      originalHeaderConfig: [],
      searchForm: {
        name: '',
        address: '',
        mobile: '',
        contractNo: '',
        contractStatus: '',
        isArchive: '',
        isAudit: '',
        productionOrder: '',
        productionStatus: '',
        storeName: '',
        guideNickName: '',
        designerNickName: '',
        createDateRange: null,
        orderClerkTimeRange: null
      },
      selectedStatus: '全部',
      statusCounts: {},
      allChecked: false,
      selectedContractIds: [],
      checkedContracts: [],
      checkedOrders: [],
      downloadingContractId: '',
      // 加急申请相关
      showUrgentApplyDialog: false,
      isEditMode: false,
      urgentApplyForm: {
        title: '',
        custName: '',
        applyDate: '',
        applyReason: '',
        custAddress: '',
        remark: ''
      },
      urgentApplyFiles: [],
      // 改单相关
      showModifyOrderDialog: false,
      modifyOrderForm: {
        contractId: '',
        serverUserName: '',
        serverNickName: '',
        questionType: '',
        problemDescription: ''
      },
      modifyOrderFiles: [],
      modifyOrderImages: [],
      modifyOrderVideos: [],
      currentModifyOrder: null,
      modifyOrderContractId: '',
      modifyOrderContractNo: '',
      showCustomerUserSelect: false,
      customerSelectTarget: '',
      // 'modify' or 'addOrder'
      // 补单相关
      showAddOrderDialog: false,
      addOrderForm: {
        reason: '',
        order: null,
        bomList: [],
        selectedBomList: [],
        searchCode: '',
        searchName: '',
        searchColor: '',
        searchBarCode: '',
        searchMaterialTypeInfo: '',
        searchLength: '',
        searchWidth: '',
        searchHeight: '',
        searchQuantity: '',
        searchRemark: '',
        questionType: '',
        serverUserName: '',
        serverNickName: '',
        problemDescription: ''
      },
      addOrderFiles: [],
      addOrderImages: [],
      addOrderVideos: [],
      addOrderContractId: '',
      addOrderContractNo: '',
      showAddOrderCustomerSelect: false,
      // 批量付款相关
      showBatchPayDialog: false,
      batchPayForm: {
        contractIds: [],
        contractNo: '',
        custName: '',
        custAddress: '',
        orderNo: '',
        productionOrder: '',
        title: '',
        payReason: '',
        totalAmount: '',
        receivingAccount: '',
        remark: ''
      },
      batchPayFiles: [],
      // 批量付款提交中状态（防重复提交 + 按钮 loading）
      batchPaySubmitting: false,
      // 单个付款相关
      showPayDialog: false,
      payForm: {
        orderId: '',
        orderNo: '',
        contractId: '',
        contractNo: '',
        custName: '',
        custAddress: '',
        remark: '',
        title: '',
        payReason: '',
        totalAmount: '',
        receivingAccount: '',
        productionOrder: ''
      },
      payFiles: [],
      // 单个付款提交中状态（防重复提交 + 按钮 loading）
      paySubmitting: false,
      // 单个取消相关
      showCancelDialog: false,
      cancelForm: {
        orderId: '',
        orderNo: '',
        contractId: '',
        contractNo: '',
        custName: '',
        custAddress: '',
        orderDate: '',
        orderApprovalDate: '',
        plannedDeliveryDate: '',
        applyDate: '',
        applyReason: '',
        remark: '',
        urgentAfterReorder: '',
        title: '',
        productionOrder: ''
      },
      cancelFiles: [],
      cancelSubmitting: false,
      // 订单回退相关
      showRollbackDialog: false,
      rollbackForm: {
        orderId: '',
        orderNo: '',
        contractId: '',
        contractNo: '',
        custName: '',
        custAddress: '',
        orderDate: '',
        orderApprovalDate: '',
        plannedDeliveryDate: '',
        applyDate: '',
        applyReason: '',
        remark: '',
        productionOrder: ''
      },
      rollbackFiles: [],
      // 订单详情相关
      showOrderDetailDialog: false,
      currentOrder: null,
      contractList: [],
      currentPage: 1,
      pageSize: 10,
      total: 4,
      // 导出相关
      showExportDialog: false,
      exportSelectedFields: [],
      exportSelectAll: false
    };
  },
  methods: {
    // 监听屏幕高度变化
    handleResize: function handleResize() {
      this.screenHeight = document.documentElement.clientHeight || document.body.clientHeight;
    },
    // 初始化表头配置
    initTableHeader: function initTableHeader() {
      var fields = this.dict.order_display_fields.filter(function (item) {
        return item.value && item.label;
      });
      this.tableHeader = fields.map(function (item, index) {
        return {
          key: item.value,
          label: item.label,
          visible: item.unit !== false && item.unit !== 'false',
          sort: item.dictSort || index
        };
      });
      this.loadHeaderConfig();
    },
    // 加载表头配置
    loadHeaderConfig: function loadHeaderConfig() {
      var _this2 = this;

      if (!this.tableHeader || this.tableHeader.length === 0) return;
      var savedConfig = localStorage.getItem('orderHeaderConfig');

      if (savedConfig) {
        try {
          var config = JSON.parse(savedConfig);
          config.forEach(function (item) {
            var col = _this2.tableHeader.find(function (col) {
              return col.key === item.key;
            });

            if (col) {
              col.visible = item.visible;
              col.sort = item.sort !== undefined ? item.sort : col.sort;
            }
          });
          this.tableHeader.sort(function (a, b) {
            return a.sort - b.sort;
          });
        } catch (e) {
          console.error('加载表头配置失败:', e);
        }
      }
    },
    // 判断列是否可见
    isColumnVisible: function isColumnVisible(key) {
      var col = this.tableHeader.find(function (c) {
        return c.key === key;
      });
      return col ? col.visible : true;
    },
    // 切换列显示/隐藏
    toggleColumnVisible: function toggleColumnVisible(key) {
      var col = this.tableHeader.find(function (c) {
        return c.key === key;
      });

      if (col) {
        col.visible = !col.visible;
      }
    },
    // 获取列值
    getColumnValue: function getColumnValue(key, row) {
      if (!row) return '-';
      if (key === 'name') return row[key] ? row[key] : '-';
      if (key === 'mobile') return row[key] || '-';
      if (key === 'address') return row[key] || '-';

      if (key === 'amount') {
        if (this.$parent.checkPer(['admin', 'orders:viewAmount'])) {
          return "\xA5".concat((row[key] || 0).toFixed(2));
        }

        return '***';
      }

      if (key === 'custStatus') {
        return row.custStatus || '未知';
      }

      if (key === 'customerStats') {
        return "\u5408\u540C ".concat(row.contractNum || 0, " \u4E2A, \u8BA2\u5355 ").concat(row.orderNum || 0, " \u4E2A, \u552E\u540E ").concat(row.afterNum || 0, " \u4E2A");
      }

      if (key === 'contractImgs') {
        var imgs = this.parseContractImgs(row.contractImgs);
        return imgs.length > 0 ? "".concat(imgs.length, " \u5F20") : '-';
      }

      if (key === 'file') {
        var files = this.parseContractFiles(row.file);
        return files.length > 0 ? "".concat(files.length, " \u4E2A") : '-';
      }

      if (key === 'contractNo') {
        return row[key] || '待填合同号';
      }

      if (key === 'designerNickName' || key === 'orderClerkNickName' || key === 'guideNickName') {
        return this.parseNickName(row[key]);
      }

      return row[key] || '-';
    },
    // 获取字符串显示宽度
    getStrWidth: function getStrWidth(str) {
      var width = 0;

      var _iterator = _createForOfIteratorHelper(String(str)),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var char = _step.value;

          if (/[\u4e00-\u9fa5]/.test(char)) {
            width += 24;
          } else if (/[0-9]/.test(char)) {
            width += 10;
          } else {
            width += 10;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return width;
    },
    // 获取列宽度
    getColumnWidth: function getColumnWidth(key) {
      var _this3 = this;

      if (key === 'customerStats') {
        return 300;
      }

      if (!this.contractList || this.contractList.length === 0) {
        return 140;
      }

      var col = this.tableHeader.find(function (c) {
        return c.key === key;
      });
      var headerWidth = this.getStrWidth(col ? col.label : key);
      var values = this.contractList.map(function (row) {
        return _this3.getColumnValue(key, row) || '';
      });
      var dataWidth = Math.max.apply(Math, (0, _toConsumableArray2.default)(values.map(function (v) {
        return _this3.getStrWidth(v);
      })));
      var maxWidth = Math.max(headerWidth, dataWidth);
      var minWidth = 80;
      return Math.max(maxWidth + 20, minWidth);
    },
    // 全部左移（隐藏所有列）
    moveAllToLeft: function moveAllToLeft() {
      this.tableHeader.forEach(function (col) {
        col.visible = false;
      });
    },
    // 全部右移（显示所有列）
    moveAllToRight: function moveAllToRight() {
      this.tableHeader.forEach(function (col) {
        col.visible = true;
      });
    },
    // 打开配置弹窗
    openConfigDialog: function openConfigDialog() {
      this.originalHeaderConfig = this.tableHeader.map(function (col, index) {
        return {
          key: col.key,
          visible: col.visible,
          sort: index
        };
      });
      this.configDialogVisible = true;
    },
    // 保存表头配置
    saveHeaderConfig: function () {
      var _saveHeaderConfig = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this4 = this;

        var config, dictData, updatePromises;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                config = this.tableHeader.map(function (col, index) {
                  return {
                    key: col.key,
                    visible: col.visible,
                    sort: index
                  };
                });
                localStorage.setItem('orderHeaderConfig', JSON.stringify(config));
                dictData = this.dict.order_display_fields;
                updatePromises = [];
                config.forEach(function (item, index) {
                  var originalItem = _this4.originalHeaderConfig.find(function (o) {
                    return o.key === item.key;
                  });

                  if (originalItem && (originalItem.visible !== item.visible || originalItem.sort !== index)) {
                    var dictItem = dictData.find(function (d) {
                      return d.value === item.key;
                    });

                    if (dictItem && dictItem.id) {
                      updatePromises.push((0, _dictDetail.edit)({
                        id: dictItem.id,
                        dict: {
                          id: dictItem.dict.id
                        },
                        value: dictItem.value,
                        label: dictItem.label,
                        unit: item.visible,
                        dictSort: index
                      }));
                    }
                  }
                });

                if (!(updatePromises.length > 0)) {
                  _context.next = 20;
                  break;
                }

                _context.prev = 6;
                _context.next = 9;
                return Promise.all(updatePromises);

              case 9:
                this.$message.success('配置已保存');
                this.$nextTick(function () {
                  _this4.handleSearch();
                });
                _context.next = 18;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](6);
                console.error('保存字典配置失败:', _context.t0);
                this.$message.warning('本地保存成功，但服务器保存失败');
                this.$nextTick(function () {
                  _this4.handleSearch();
                });

              case 18:
                _context.next = 22;
                break;

              case 20:
                this.$message.success('配置已保存');
                this.$nextTick(function () {
                  _this4.handleSearch();
                });

              case 22:
                this.configDialogVisible = false;

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 13]]);
      }));

      function saveHeaderConfig() {
        return _saveHeaderConfig.apply(this, arguments);
      }

      return saveHeaderConfig;
    }(),
    // 重置表头配置
    resetHeaderConfig: function resetHeaderConfig() {
      var fields = this.dict.order_display_fields.filter(function (item) {
        return item.value && item.label;
      });
      var newTableHeader = fields.map(function (item, index) {
        return {
          key: item.value,
          label: item.label,
          visible: item.unit !== false && item.unit !== 'false',
          sort: item.dictSort || index
        };
      });
      newTableHeader.sort(function (a, b) {
        return a.sort - b.sort;
      });
      this.tableHeader = newTableHeader;
    },
    getStatusCounts: function () {
      var _getStatusCounts = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params, response;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                params = this.buildSearchParams();
                _context2.next = 4;
                return (0, _order.countCustByOrderStatus)(params);

              case 4:
                response = _context2.sent;
                this.statusCounts = response.data;
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);
                console.error('获取状态统计失败:', _context2.t0);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 8]]);
      }));

      function getStatusCounts() {
        return _getStatusCounts.apply(this, arguments);
      }

      return getStatusCounts;
    }(),
    getStatusTagType: function getStatusTagType(status) {
      var statusMap = {
        '待处理': 'warning',
        '已发货': 'primary',
        '已安装': 'success',
        '已完成': 'success',
        '待审核': 'info',
        '被退回': 'danger',
        '待付款': 'warning',
        '待入库': 'primary',
        '齐套待预约': 'primary',
        '待发货': 'info',
        '不齐套发货': 'warning',
        '售后中': 'danger'
      };
      return statusMap[status] || 'info';
    },
    getStatusClass: function getStatusClass(status) {
      var statusMap = {
        '待处理': 'warning',
        '已发货': 'primary',
        '已安装': 'success',
        '已完成': 'success',
        '待审核': 'info',
        '被退回': 'danger',
        '待付款': 'warning',
        '待入库': 'primary',
        '齐套待预约': 'primary',
        '待发货': 'info',
        '不齐套发货': 'warning',
        '售后中': 'danger'
      };
      return statusMap[status] || 'info';
    },
    // 切换订单展开状态
    toggleGroup: function toggleGroup(orderId) {
      if (this.collapsedOrders.includes(orderId)) {
        this.collapsedOrders = this.collapsedOrders.filter(function (id) {
          return id !== orderId;
        });
      } else {
        this.collapsedOrders.push(orderId);
      }
    },
    // 切换合同展开状态
    toggleContract: function toggleContract(contractId) {
      var index = this.collapsedContracts.indexOf(contractId);

      if (index > -1) {
        this.collapsedContracts.splice(index, 1);
      } else {
        this.collapsedContracts.push(contractId);
      }
    },
    // 检查合同是否展开
    isContractExpanded: function isContractExpanded(contractId) {
      return !this.collapsedContracts.includes(contractId);
    },
    // 合同行点击事件
    handleContractRowClick: function handleContractRowClick(row, column) {
      this.$refs.contractTable.toggleRowExpansion(row);
    },
    handleViewOrder: function handleViewOrder(order) {
      // 打开订单详情弹窗
      this.currentOrder = order;
      this.showOrderDetailDialog = true;
    },
    handleEditOrder: function handleEditOrder(row) {
      this.$message.info('编辑订单: ' + row.orderNo);
    },
    handleDeleteOrder: function handleDeleteOrder(id) {
      var _this5 = this;

      this.$confirm('确定要删除这个订单吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this5.$message.success('删除成功');
      }).catch(function () {
        _this5.$message.info('已取消删除');
      });
    },
    // 搜索按钮点击
    handleSearchClick: function handleSearchClick() {
      this.currentPage = 1;
      this.handleSearch();
    },
    handleSearch: function handleSearch() {
      var _this6 = this;

      this.searchLoading = true;
      var params = this.buildSearchParams();
      params.size = this.pageSize;
      params.page = this.currentPage - 1;
      (0, _contract2.queryContract)(params).then(function (response) {
        if (response.code === 200) {
          _this6.contractList = response.data.content;
          _this6.total = response.data.totalElements;
          _this6.collapsedOrders = _this6.contractList.map(function (contract) {
            return contract.id;
          });
          _this6.collapsedContracts = [];
        } else {
          _this6.$message.error(response.msg || '查询失败');
        }
      }).catch(function (error) {
        console.error('查询订单失败:', error);

        _this6.$message.error('网络错误，请稍后重试');
      }).finally(function () {
        _this6.searchLoading = false;
      }); // 同步更新状态统计

      this.getStatusCounts();
    },
    buildSearchParams: function buildSearchParams() {
      var params = {};
      if (this.searchForm.name) params.name = this.searchForm.name;
      if (this.searchForm.address) params.address = this.searchForm.address;
      if (this.searchForm.mobile) params.mobile = this.searchForm.mobile;
      if (this.searchForm.contractNo) params.contractNo = this.searchForm.contractNo;
      if (this.searchForm.contractStatus) params.contractStatus = this.searchForm.contractStatus;
      if (this.searchForm.isArchive) params.isArchive = this.searchForm.isArchive;
      if (this.searchForm.isAudit) params.isAudit = this.searchForm.isAudit;
      if (this.searchForm.productionOrder) params.productionOrder = this.searchForm.productionOrder;
      if (this.searchForm.productionStatus) params.productionStatus = this.searchForm.productionStatus;
      if (this.searchForm.storeName) params.storeName = this.searchForm.storeName;
      if (this.searchForm.guideNickName) params.guideNickName = this.searchForm.guideNickName;
      if (this.searchForm.designerNickName) params.designerNickName = this.searchForm.designerNickName;

      if (this.searchForm.createDateRange && this.searchForm.createDateRange.length === 2) {
        params.createDateBegin = this.searchForm.createDateRange[0];
        params.createDateEnd = this.searchForm.createDateRange[1];
      }

      if (this.searchForm.orderClerkTimeRange && this.searchForm.orderClerkTimeRange.length === 2) {
        params.orderClerkTimeBegin = this.searchForm.orderClerkTimeRange[0];
        params.orderClerkTimeEnd = this.searchForm.orderClerkTimeRange[1];
      }

      return params;
    },
    resolveCustName: function resolveCustName(contract) {
      var order = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return contract.contactPerson || contract.custName || contract.customerName || contract.name || order.custName || order.customerName || order.contactPerson || order.name || '';
    },
    resolveCustAddress: function resolveCustAddress(contract) {
      var order = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return contract.contactAddress || contract.custAddress || contract.address || order.custAddress || order.customerAddress || order.contactAddress || order.address || '';
    },
    resetSearch: function resetSearch() {
      this.searchForm = {
        name: '',
        address: '',
        mobile: '',
        contractNo: '',
        contractStatus: '',
        isArchive: '',
        isAudit: '',
        productionOrder: '',
        productionStatus: '',
        storeName: '',
        guideNickName: '',
        designerNickName: '',
        createDateRange: null,
        orderClerkTimeRange: null
      };
      this.showMoreSearch = false;
      this.handleSearch();
    },
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.handleSearch();
    },
    handleCurrentChange: function handleCurrentChange(current) {
      this.currentPage = current;
      this.handleSearch();
    },
    // 行点击事件
    handleRowClick: function handleRowClick(row) {
      this.$refs.contractTable.toggleRowExpansion(row);
    },
    handleToggleExpand: function handleToggleExpand() {
      this.isAllExpanded = !this.isAllExpanded;

      if (this.isAllExpanded) {
        this.handleExpandAll();
      } else {
        this.handleCollapseAll();
      }
    },
    // 全部展开
    handleExpandAll: function handleExpandAll() {
      var _this7 = this;

      this.contractList.forEach(function (contract) {
        _this7.$refs.contractTable.toggleRowExpansion(contract, true);
      });
      this.collapsedContracts = [];
    },
    // 全部折叠
    handleCollapseAll: function handleCollapseAll() {
      var _this8 = this;

      this.contractList.forEach(function (contract) {
        _this8.$refs.contractTable.toggleRowExpansion(contract, false);
      });
      this.collapsedContracts = [];
    },
    // 导出：打开弹窗
    openExportDialog: function openExportDialog() {
      // 默认选中当前可见列
      this.exportSelectedFields = this.tableHeader.filter(function (h) {
        return h.visible;
      }).map(function (h) {
        return h.key;
      });
      this.exportSelectAll = this.exportSelectedFields.length === this.tableHeader.length;
      this.showExportDialog = true;
    },
    toggleExportSelectAll: function toggleExportSelectAll(val) {
      if (val) {
        this.exportSelectedFields = this.tableHeader.map(function (h) {
          return h.key;
        });
      } else {
        this.exportSelectedFields = [];
      }
    },
    confirmExport: function confirmExport() {
      var _this9 = this;

      if (!this.exportSelectedFields || this.exportSelectedFields.length === 0) {
        this.$message.warning('请先选择要导出的字段');
        return;
      } // 组装表头


      var headers = this.exportSelectedFields.map(function (key) {
        var col = _this9.tableHeader.find(function (c) {
          return c.key === key;
        });

        return col ? col.label : key;
      }); // 调用后端导出接口，传入查询条件和导出字段（GET，exportFields 以重复参数形式发送）

      var criteria = this.buildSearchParams();
      var searchParams = new URLSearchParams();
      Object.keys(criteria || {}).forEach(function (key) {
        var val = criteria[key];
        if (val === undefined || val === null || val === '') return;

        if (Array.isArray(val)) {
          val.forEach(function (v) {
            return searchParams.append(key, v);
          });
        } else {
          searchParams.append(key, val);
        }
      });
      this.exportSelectedFields.forEach(function (f) {
        return searchParams.append('exportFields', f);
      });
      this.$message({
        message: '导出中，请稍候...',
        duration: 0
      });
      (0, _contract2.downloadAllAndCust)(searchParams).then(function (blob) {
        // 处理下载
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url; // 尝试从 response header 获取文件名（如果后端设置） - 此处无法访问 headers 因为 request 返回 data only

        var filename = 'orders_export_' + new Date().toISOString().slice(0, 19).replace(/[:T]/g, '-') + '.xlsx';
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        _this9.showExportDialog = false;

        _this9.$message.closeAll();

        _this9.$message.success('导出完成，文件将下载到您的浏览器');
      }).catch(function (err) {
        _this9.$message.closeAll();

        _this9.$message.error('导出失败');

        console.error('导出失败:', err);
      });
    },
    // 合同层级批量操作
    handleContractBatchCommand: function handleContractBatchCommand(command, contract) {
      // 批量下载不依赖勾选状态
      if (command === 'download') {
        this.handleBatchDownloadAttachments(contract);
        return;
      }

      var contractId = contract.id;

      if (!this.checkedContracts.includes(contractId)) {
        this.checkedContracts.push(contractId);
      }

      switch (command) {
        case 'urgent':
          this.handleUrgent(contract);
          break;

        case 'pay':
          if (!this.$parent.checkPer(['admin', 'contract:pay'])) {
            this.$message.error('没有付款权限');
            break;
          }

          this.handleBatchPay();
          break;

        case 'rollback':
          this.handleBatchRollback();
          break;

        case 'cancel':
          this.handleBatchCancel();
          break;
      }

      var index = this.checkedContracts.indexOf(contractId);

      if (index > -1) {
        this.checkedContracts.splice(index, 1);
      }
    },
    // 同步合同
    handleSyncContract: function handleSyncContract(contract) {
      var _this10 = this;

      this.$confirm("\u786E\u8BA4\u540C\u6B65\u5408\u540C ".concat(contract.contractNo, " \u7684\u6700\u65B0\u72B6\u6001\u5417\uFF1F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _contract2.manualSyncByContract)(contract.contractNo).then(function (res) {
          if (res.code === 200) {
            _this10.$message.success('同步成功');

            _this10.handleSearch();
          } else {
            _this10.$message.error(res.msg || '同步失败');
          }
        }).catch(function () {
          _this10.$message.error('同步失败，请稍后重试');
        });
      }).catch(function () {});
    },
    // 批量下载当前合同下所有订单的附件
    handleBatchDownloadAttachments: function () {
      var _handleBatchDownloadAttachments = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(contract) {
        var contractNo, loading, _closeLoading, res, isOk, list, attachments, i;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this.downloadingContractId) {
                  _context3.next = 3;
                  break;
                }

                this.$message.warning('附件正在下载中，请稍候');
                return _context3.abrupt("return");

              case 3:
                contractNo = contract.contractNo;

                if (contractNo) {
                  _context3.next = 7;
                  break;
                }

                this.$message.warning('当前合同缺少合同号，无法下载附件');
                return _context3.abrupt("return");

              case 7:
                _context3.prev = 7;
                _context3.next = 10;
                return this.$confirm("\u786E\u8BA4\u4E0B\u8F7D\u5408\u540C ".concat(contractNo, " \u7684\u6240\u6709\u8BA2\u5355\u9644\u4EF6\u5417\uFF1F"), '批量下载', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                });

              case 10:
                _context3.next = 15;
                break;

              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3["catch"](7);
                return _context3.abrupt("return");

              case 15:
                this.downloadingContractId = contract.id;
                loading = this.$loading({
                  lock: true,
                  text: '正在获取订单附件，请稍候...',
                  spinner: 'el-icon-loading',
                  background: 'rgba(0, 0, 0, 0.7)'
                });

                _closeLoading = function closeLoading() {
                  loading.close();

                  _closeLoading = function closeLoading() {};
                };

                _context3.prev = 18;
                _context3.next = 21;
                return (0, _contract2.getContractOrderAttachments)({
                  reportId: 29,
                  whereSql: JSON.stringify({
                    ContractNo: contractNo
                  }),
                  isPreview: true
                });

              case 21:
                res = _context3.sent;
                isOk = res && (res.code === 200 || res.code === 0);
                list = isOk && Array.isArray(res.data) ? res.data : [];
                attachments = list.filter(function (item) {
                  return item && item.url;
                });

                _closeLoading();

                if (!(attachments.length === 0)) {
                  _context3.next = 29;
                  break;
                }

                this.$message.warning('当前合同暂无订单附件');
                return _context3.abrupt("return");

              case 29:
                this.$message({
                  message: "\u5171\u83B7\u53D6\u5230 ".concat(attachments.length, " \u4E2A\u9644\u4EF6\uFF0C\u5F00\u59CB\u4E0B\u8F7D..."),
                  duration: 3000
                });
                i = 0;

              case 31:
                if (!(i < attachments.length)) {
                  _context3.next = 39;
                  break;
                }

                _context3.next = 34;
                return this.downloadOrderAttachment(attachments[i], i);

              case 34:
                _context3.next = 36;
                return new Promise(function (resolve) {
                  return setTimeout(resolve, 300);
                });

              case 36:
                i++;
                _context3.next = 31;
                break;

              case 39:
                this.$message.success("\u5DF2\u5B8C\u6210 ".concat(attachments.length, " \u4E2A\u9644\u4EF6\u4E0B\u8F7D"));
                _context3.next = 46;
                break;

              case 42:
                _context3.prev = 42;
                _context3.t1 = _context3["catch"](18);
                console.error('批量下载订单附件失败:', _context3.t1);
                this.$message.error(_context3.t1 && _context3.t1.message && _context3.t1.message !== 'cancel' ? _context3.t1.message : '批量下载附件失败，请稍后重试');

              case 46:
                _context3.prev = 46;

                _closeLoading();

                this.downloadingContractId = '';
                return _context3.finish(46);

              case 50:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[7, 12], [18, 42, 46, 50]]);
      }));

      function handleBatchDownloadAttachments(_x) {
        return _handleBatchDownloadAttachments.apply(this, arguments);
      }

      return handleBatchDownloadAttachments;
    }(),
    // 下载单个订单附件
    downloadOrderAttachment: function () {
      var _downloadOrderAttachment = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(att, index) {
        var fileUrl, fileName, response, blob;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                fileUrl = att.url;
                fileName = att.fileName || this.getFileNameFromUrl(fileUrl) || "\u9644\u4EF6".concat(index + 1);
                _context4.prev = 2;
                _context4.next = 5;
                return fetch(fileUrl);

              case 5:
                response = _context4.sent;

                if (response.ok) {
                  _context4.next = 8;
                  break;
                }

                throw new Error('附件下载失败');

              case 8:
                _context4.next = 10;
                return response.blob();

              case 10:
                blob = _context4.sent;
                this.saveBlobAsFile(blob, fileName);
                _context4.next = 17;
                break;

              case 14:
                _context4.prev = 14;
                _context4.t0 = _context4["catch"](2);
                // 无跨域权限时直接新窗口打开附件地址
                window.open(fileUrl, '_blank');

              case 17:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[2, 14]]);
      }));

      function downloadOrderAttachment(_x2, _x3) {
        return _downloadOrderAttachment.apply(this, arguments);
      }

      return downloadOrderAttachment;
    }(),
    saveBlobAsFile: function saveBlobAsFile(blob, fileName) {
      var blobUrl = URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = blobUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(blobUrl);
    },
    getFileNameFromUrl: function getFileNameFromUrl(url) {
      if (!url) {
        return '';
      }

      try {
        var path = url.split('?')[0].split('#')[0];
        return decodeURIComponent(path.substring(path.lastIndexOf('/') + 1));
      } catch (e) {
        return '';
      }
    },
    // 批量下单
    handleBatchOrder: function () {
      var _handleBatchOrder = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var response;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(this.checkedContracts.length === 0)) {
                  _context5.next = 3;
                  break;
                }

                this.$message.warning('请先选择要下单的合同');
                return _context5.abrupt("return");

              case 3:
                _context5.prev = 3;
                _context5.next = 6;
                return this.$confirm('确认要对选中的合同进行批量下单吗？', '批量下单确认', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                });

              case 6:
                _context5.next = 8;
                return (0, _order.batchCreateMesByContractId)(this.checkedContracts);

              case 8:
                response = _context5.sent;

                if (response.code === 200) {
                  this.$message.success('批量下单成功');
                  this.handleSearch();
                } else {
                  this.$message.error(response.msg || '批量下单失败');
                }

                _context5.next = 15;
                break;

              case 12:
                _context5.prev = 12;
                _context5.t0 = _context5["catch"](3);

                if (_context5.t0 !== 'cancel') {
                  console.error('批量下单失败:', _context5.t0);
                  this.$message.error('网络错误，请稍后重试');
                }

              case 15:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[3, 12]]);
      }));

      function handleBatchOrder() {
        return _handleBatchOrder.apply(this, arguments);
      }

      return handleBatchOrder;
    }(),
    // 批量付款
    handleBatchPay: function () {
      var _handleBatchPay = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var orderInfos, orderNos, contractNos, contractIds, firstOrder, validOrderNos, totalAmount, contractNoSet, _iterator2, _step2, contractNo, res;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(this.checkedContracts.length === 0)) {
                  _context6.next = 3;
                  break;
                }

                this.$message.warning('请先选择要付款的合同');
                return _context6.abrupt("return");

              case 3:
                orderInfos = this.getSelectedOrderInfos().filter(function (o) {
                  return o.productionStatus === '待经销商确认';
                });

                if (!(orderInfos.length === 0)) {
                  _context6.next = 7;
                  break;
                }

                this.$message.warning('所选合同下没有可付款的订单（需为待经销商确认状态）');
                return _context6.abrupt("return");

              case 7:
                orderNos = orderInfos.map(function (o) {
                  return o.orderNo;
                }).join('、');
                contractNos = (0, _toConsumableArray2.default)(new Set(orderInfos.map(function (o) {
                  return o.contractNo;
                }))).join('、');
                contractIds = (0, _toConsumableArray2.default)(new Set(orderInfos.map(function (o) {
                  return o.contractId;
                })));
                firstOrder = orderInfos[0]; // 从报价信息中获取总金额（只统计非取消状态的可付款订单）

                validOrderNos = new Set(orderInfos.map(function (o) {
                  return o.orderNo;
                }));
                totalAmount = 0;
                contractNoSet = (0, _toConsumableArray2.default)(new Set(orderInfos.map(function (o) {
                  return o.contractNo;
                })));
                _iterator2 = _createForOfIteratorHelper(contractNoSet);
                _context6.prev = 15;

                _iterator2.s();

              case 17:
                if ((_step2 = _iterator2.n()).done) {
                  _context6.next = 31;
                  break;
                }

                contractNo = _step2.value;
                _context6.prev = 19;
                _context6.next = 22;
                return (0, _contract2.getOrderQuote)({
                  contractNumber: contractNo
                });

              case 22:
                res = _context6.sent;

                if (res.code === 200 && res.data) {
                  res.data.forEach(function (item) {
                    // 只统计有效订单的报价，排除已取消的订单
                    var orderNo = item.productionOrder || item.salesOrderId || item.orderNo || '';

                    if (orderNo && validOrderNos.has(orderNo) && item.quotes && item.quotes.length > 0) {
                      var subtotal = item.quotes.reduce(function (sum, q) {
                        return sum + (q.totalAmount || 0);
                      }, 0);
                      totalAmount += subtotal;
                    }
                  });
                }

                _context6.next = 29;
                break;

              case 26:
                _context6.prev = 26;
                _context6.t0 = _context6["catch"](19);
                console.error('获取报价信息失败:', _context6.t0);

              case 29:
                _context6.next = 17;
                break;

              case 31:
                _context6.next = 36;
                break;

              case 33:
                _context6.prev = 33;
                _context6.t1 = _context6["catch"](15);

                _iterator2.e(_context6.t1);

              case 36:
                _context6.prev = 36;

                _iterator2.f();

                return _context6.finish(36);

              case 39:
                // 初始化批量付款表单
                this.batchPayForm = {
                  contractIds: contractIds,
                  contractNo: contractNos,
                  custName: firstOrder.custName || '',
                  custAddress: firstOrder.custAddress || '',
                  orderNo: orderNos,
                  productionOrder: orderNos,
                  title: '',
                  payReason: '',
                  totalAmount: totalAmount,
                  receivingAccount: '',
                  remark: ''
                }; // 清空之前的附件

                this.batchPayFiles = []; // 清空上传组件

                if (this.$refs.batchPayFileUpload) {
                  this.$refs.batchPayFileUpload.clearImgs();
                } // 打开批量付款弹窗


                this.showBatchPayDialog = true;

              case 43:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[15, 33, 36, 39], [19, 26]]);
      }));

      function handleBatchPay() {
        return _handleBatchPay.apply(this, arguments);
      }

      return handleBatchPay;
    }(),
    // 批量确认报价（仅确认对话框，不弹表单）
    handleBatchPaySimple: function () {
      var _handleBatchPaySimple = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var response;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!(this.checkedContracts.length === 0)) {
                  _context7.next = 3;
                  break;
                }

                this.$message.warning('请先选择要确认报价的合同');
                return _context7.abrupt("return");

              case 3:
                _context7.prev = 3;
                _context7.next = 6;
                return this.$confirm('确认要对选中的合同进行批量确认报价吗？', '批量确认报价', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                });

              case 6:
                _context7.next = 8;
                return (0, _contract2.addPaySales)({
                  contractids: this.checkedContracts
                });

              case 8:
                response = _context7.sent;

                if (response.code === 200) {
                  this.$message.success('批量确认报价成功');
                  this.handleSearch();
                } else {
                  this.$message.error(response.msg || '批量确认报价失败');
                }

                _context7.next = 15;
                break;

              case 12:
                _context7.prev = 12;
                _context7.t0 = _context7["catch"](3);

                if (_context7.t0 !== 'cancel') {
                  console.error('批量确认报价失败:', _context7.t0);
                  this.$message.error('网络错误，请稍后重试');
                }

              case 15:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[3, 12]]);
      }));

      function handleBatchPaySimple() {
        return _handleBatchPaySimple.apply(this, arguments);
      }

      return handleBatchPaySimple;
    }(),
    // 批量回退
    handleBatchRollback: function () {
      var _handleBatchRollback = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var orderInfos, orderNos, contractNos, contractIds, firstOrder;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!(this.checkedContracts.length === 0)) {
                  _context8.next = 3;
                  break;
                }

                this.$message.warning('请先选择要回退的合同');
                return _context8.abrupt("return");

              case 3:
                orderInfos = this.getSelectedOrderInfos();

                if (!(orderInfos.length === 0)) {
                  _context8.next = 7;
                  break;
                }

                this.$message.warning('所选合同下没有可回退的订单');
                return _context8.abrupt("return");

              case 7:
                orderNos = orderInfos.map(function (o) {
                  return o.orderNo;
                }).join('、');
                contractNos = (0, _toConsumableArray2.default)(new Set(orderInfos.map(function (o) {
                  return o.contractNo;
                }))).join('、');
                contractIds = (0, _toConsumableArray2.default)(new Set(orderInfos.map(function (o) {
                  return o.contractId;
                })));
                firstOrder = orderInfos[0];
                this.rollbackForm = {
                  orderId: '',
                  orderNo: orderNos,
                  contractId: contractIds,
                  contractNo: contractNos,
                  custName: firstOrder.custName || '',
                  custAddress: firstOrder.custAddress || '',
                  orderDate: firstOrder.orderDate ? firstOrder.orderDate.slice(0, 10) : '',
                  orderApprovalDate: '',
                  plannedDeliveryDate: '',
                  applyDate: new Date().toISOString().slice(0, 10),
                  applyReason: '',
                  remark: '',
                  productionOrder: orderNos,
                  batchOrderIds: orderInfos.map(function (o) {
                    return o.orderId;
                  })
                };
                this.rollbackFiles = [];

                if (this.$refs.rollbackFileUpload) {
                  this.$refs.rollbackFileUpload.clearImgs();
                }

                this.showRollbackDialog = true;

              case 15:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function handleBatchRollback() {
        return _handleBatchRollback.apply(this, arguments);
      }

      return handleBatchRollback;
    }(),
    // 批量加急
    handleBatchUrgent: function handleBatchUrgent() {
      if (this.checkedContracts.length === 0) {
        this.$message.warning('请先选择要加急的合同');
        return;
      }

      var orderInfos = this.getSelectedOrderInfos();

      if (orderInfos.length === 0) {
        this.$message.warning('所选合同下没有可加急的订单');
        return;
      }

      var orderNos = orderInfos.map(function (o) {
        return o.orderNo;
      }).join('、');
      var contractNos = (0, _toConsumableArray2.default)(new Set(orderInfos.map(function (o) {
        return o.contractNo;
      }))).join('、');
      var contractIds = (0, _toConsumableArray2.default)(new Set(orderInfos.map(function (o) {
        return o.contractId;
      })));
      var firstOrder = orderInfos[0];
      this.urgentApplyForm = {
        orderId: '',
        orderNo: orderNos,
        contractId: contractIds,
        contractNo: contractNos,
        custName: firstOrder.custName || '',
        custAddress: firstOrder.custAddress || '',
        orderDate: firstOrder.orderDate ? firstOrder.orderDate.slice(0, 10) : '',
        applyDate: new Date().toISOString().slice(0, 10),
        applyReason: '',
        title: '',
        productionOrder: orderNos,
        batchOrderIds: orderInfos.map(function (o) {
          return o.orderId;
        })
      };
      this.showUrgentApplyDialog = true;
    },
    // 批量取消
    handleBatchCancel: function handleBatchCancel() {
      var _this11 = this;

      if (this.checkedOrders.length === 0) {
        this.$message.warning('请先勾选要取消的订单');
        return;
      }

      var allOrderInfos = this.getSelectedOrderInfos().filter(function (o) {
        return _this11.checkedOrders.includes(o.orderId);
      }); // 过滤掉不可取消的订单状态（回退/退回/订单退回均可取消）

      var disabledStatuses = ['未提交'];
      var disabledOrders = allOrderInfos.filter(function (o) {
        return disabledStatuses.includes(o.productionStatus);
      });
      var orderInfos = allOrderInfos.filter(function (o) {
        return !disabledStatuses.includes(o.productionStatus);
      });

      if (disabledOrders.length > 0) {
        var disabledOrderNos = disabledOrders.map(function (o) {
          return o.orderNo;
        }).join('、');
        this.$message.warning('订单(' + disabledOrderNos + ')状态为未提交，不可取消，已自动跳过');
      }

      if (orderInfos.length === 0) {
        return;
      }

      var orderNos = orderInfos.map(function (o) {
        return o.orderNo;
      }).join('、');
      var contractNos = (0, _toConsumableArray2.default)(new Set(orderInfos.map(function (o) {
        return o.contractNo;
      }))).join('、');
      var contractIds = (0, _toConsumableArray2.default)(new Set(orderInfos.map(function (o) {
        return o.contractId;
      })));
      var firstOrder = orderInfos[0];
      this.cancelForm = {
        orderId: '',
        orderNo: orderNos,
        contractId: contractIds,
        contractNo: contractNos,
        custName: firstOrder.custName || '',
        custAddress: firstOrder.custAddress || '',
        orderDate: firstOrder.orderDate ? firstOrder.orderDate.slice(0, 10) : '',
        orderApprovalDate: '',
        plannedDeliveryDate: '',
        applyDate: new Date().toISOString().slice(0, 10),
        applyReason: '',
        remark: '',
        urgentAfterReorder: '',
        title: '',
        productionOrder: orderNos,
        batchOrderIds: orderInfos.map(function (o) {
          return o.orderId;
        })
      };
      this.cancelFiles = [];

      if (this.$refs.cancelFileUpload) {
        this.$refs.cancelFileUpload.clearImgs();
      }

      this.showCancelDialog = true;
    },
    // 获取选中的订单信息
    getSelectedOrderInfos: function getSelectedOrderInfos() {
      var orderInfos = [];

      var _iterator3 = _createForOfIteratorHelper(this.contractList),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var contract = _step3.value;
          if (!contract.cmsCustDesignSchemeAuditList) continue;
          if (!this.checkedContracts.includes(contract.id)) continue;

          var _iterator4 = _createForOfIteratorHelper(contract.cmsCustDesignSchemeAuditList),
              _step4;

          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var order = _step4.value;
              if (!order.rowId) continue;
              orderInfos.push({
                orderId: order.rowId,
                orderNo: order.productionOrder,
                contractId: contract.id,
                contractNo: contract.contractNo,
                custName: this.resolveCustName(contract, order),
                custAddress: this.resolveCustAddress(contract, order),
                orderDate: order.createTime || '',
                amount: order.totalPrice || order.amount || 0,
                productionStatus: order.productionStatus || ''
              });
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return orderInfos;
    },
    // 单个订单付款
    handlePayOrder: function () {
      var _handlePayOrder = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(order) {
        var contract, totalAmount, res, matchedItem;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (this.$parent.checkPer(['admin', 'contract:pay'])) {
                  _context9.next = 3;
                  break;
                }

                this.$message.error('没有付款权限');
                return _context9.abrupt("return");

              case 3:
                if (!(!order.rowId || !order.productionOrder)) {
                  _context9.next = 6;
                  break;
                }

                this.$message.error('缺少订单信息');
                return _context9.abrupt("return");

              case 6:
                // 查找当前订单所属的合同
                contract = this.contractList.find(function (c) {
                  return c.cmsCustDesignSchemeAuditList && c.cmsCustDesignSchemeAuditList.some(function (item) {
                    return item.rowId === order.rowId;
                  });
                });

                if (!(!contract || !contract.id || !contract.contractNo)) {
                  _context9.next = 10;
                  break;
                }

                this.$message.error('缺少合同信息');
                return _context9.abrupt("return");

              case 10:
                // 从报价信息中获取该订单的金额
                totalAmount = 0;
                _context9.prev = 11;
                _context9.next = 14;
                return (0, _contract2.getOrderQuote)({
                  contractNumber: contract.contractNo
                });

              case 14:
                res = _context9.sent;

                if (res.code === 200 && res.data) {
                  matchedItem = res.data.find(function (item) {
                    return item.productionOrder === order.productionOrder;
                  });

                  if (matchedItem && matchedItem.quotes) {
                    totalAmount = matchedItem.quotes.reduce(function (sum, q) {
                      return sum + (q.totalAmount || 0);
                    }, 0);
                  }
                }

                _context9.next = 21;
                break;

              case 18:
                _context9.prev = 18;
                _context9.t0 = _context9["catch"](11);
                console.error('获取报价信息失败:', _context9.t0);

              case 21:
                // 初始化付款表单
                this.payForm = {
                  orderId: order.rowId,
                  orderNo: order.productionOrder,
                  contractId: [contract.id],
                  contractNo: contract.contractNo,
                  custName: this.resolveCustName(contract, order),
                  custAddress: this.resolveCustAddress(contract, order),
                  remark: '',
                  title: '',
                  payReason: '',
                  totalAmount: totalAmount,
                  receivingAccount: '',
                  productionOrder: order.productionOrder
                }; // 清空之前的附件

                this.payFiles = [];

                if (this.$refs.payFileUpload) {
                  this.$refs.payFileUpload.clearImgs();
                } // 打开付款弹窗


                this.showPayDialog = true;

              case 25:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[11, 18]]);
      }));

      function handlePayOrder(_x4) {
        return _handlePayOrder.apply(this, arguments);
      }

      return handlePayOrder;
    }(),
    // 单个订单加急
    handleUrgentOrder: function handleUrgentOrder(order) {
      if (!order.rowId || !order.productionOrder) {
        this.$message.error('缺少订单信息');
        return;
      } // 查找当前订单所属的合同


      var contract = this.contractList.find(function (c) {
        return c.cmsCustDesignSchemeAuditList && c.cmsCustDesignSchemeAuditList.some(function (item) {
          return item.rowId === order.rowId;
        });
      });

      if (!contract || !contract.id || !contract.contractNo) {
        this.$message.error('缺少合同信息');
        return;
      } // 初始化加急表单


      this.urgentApplyForm = {
        orderId: order.rowId,
        orderNo: order.productionOrder,
        contractId: [contract.id],
        contractNo: contract.contractNo,
        applyType: '加急申请',
        title: '',
        custName: this.resolveCustName(contract, order),
        custAddress: this.resolveCustAddress(contract, order),
        applyDate: new Date().toISOString().slice(0, 10),
        applyReason: '',
        remark: ''
      }; // 清空之前的附件

      this.urgentApplyFiles = [];

      if (this.$refs.urgentApplyFileUpload) {
        this.$refs.urgentApplyFileUpload.clearImgs();
      } // 打开加急弹窗


      this.showUrgentApplyDialog = true;
    },
    // 单个订单取消
    handleCancelOrder: function handleCancelOrder(order) {
      if (!order.rowId || !order.productionOrder) {
        this.$message.error('缺少订单信息');
        return;
      } // 查找当前订单所属的合同


      var contract = this.contractList.find(function (c) {
        return c.cmsCustDesignSchemeAuditList && c.cmsCustDesignSchemeAuditList.some(function (item) {
          return item.rowId === order.rowId;
        });
      });

      if (!contract || !contract.id || !contract.contractNo) {
        this.$message.error('缺少合同信息');
        return;
      } // 初始化取消表单


      this.cancelForm = {
        orderId: order.rowId,
        orderNo: order.productionOrder,
        contractId: [contract.id],
        contractNo: contract.contractNo,
        custName: this.resolveCustName(contract, order),
        custAddress: this.resolveCustAddress(contract, order),
        orderDate: order.createTime || '',
        orderApprovalDate: '',
        plannedDeliveryDate: '',
        applyDate: new Date().toISOString().slice(0, 10),
        applyReason: '',
        remark: '',
        urgentAfterReorder: '',
        title: '',
        productionOrder: order.productionOrder
      }; // 清空之前的附件

      this.cancelFiles = [];

      if (this.$refs.cancelFileUpload) {
        this.$refs.cancelFileUpload.clearImgs();
      } // 打开取消弹窗


      this.showCancelDialog = true;
    },
    // 保存订单取消
    saveCancel: function saveCancel() {
      var _this12 = this;

      // 防止重复提交
      if (this.cancelSubmitting) {
        return;
      } // 表单验证


      if (!this.cancelForm.contractId || !this.cancelForm.contractNo || !this.cancelForm.custName || !this.cancelForm.custAddress || !this.cancelForm.orderDate || !this.cancelForm.applyDate || !this.cancelForm.applyReason || !this.cancelForm.urgentAfterReorder) {
        this.$message.error('请填写必填信息');
        return;
      } // 构建请求参数


      var params = {
        contractIds: this.cancelForm.contractId,
        contractNo: this.cancelForm.contractNo,
        custName: this.cancelForm.custName,
        custAddress: this.cancelForm.custAddress,
        orderDate: this.cancelForm.orderDate,
        orderApprovalDate: this.cancelForm.orderApprovalDate,
        plannedDeliveryDate: this.cancelForm.plannedDeliveryDate,
        applyDate: this.cancelForm.applyDate,
        applyReason: this.cancelForm.applyReason,
        remark: this.cancelForm.remark,
        urgentAfterReorder: this.cancelForm.urgentAfterReorder,
        productionOrders: this.cancelForm.productionOrder.split('、').map(function (order) {
          return order.trim();
        })
      }; // 只有当附件不为空时才添加到请求参数中

      if (this.cancelFiles && this.cancelFiles.length > 0) {
        params.files = this.cancelFiles;
      } // 调用取消接口


      this.cancelSubmitting = true;
      (0, _order.afterSales)(params).then(function (response) {
        if (response.code === 200) {
          _this12.$message.success('取消申请成功');

          _this12.showCancelDialog = false; // 刷新数据

          _this12.handleSearch(); // 清空附件


          _this12.cancelFiles = [];

          if (_this12.$refs.cancelFileUpload) {
            _this12.$refs.cancelFileUpload.clearImgs();
          }
        } else {
          _this12.$message.error(response.msg || '取消失败');
        }
      }).catch(function (error) {
        console.error('取消失败:', error);

        _this12.$message.error('网络错误，请稍后重试');
      }).finally(function () {
        _this12.cancelSubmitting = false;
      });
    },
    // 订单回退
    handleRollbackOrder: function handleRollbackOrder(order) {
      if (!order.rowId || !order.productionOrder) {
        this.$message.error('缺少订单信息');
        return;
      } // 查找当前订单所属的合同


      var contract = this.contractList.find(function (c) {
        return c.cmsCustDesignSchemeAuditList && c.cmsCustDesignSchemeAuditList.some(function (item) {
          return item.rowId === order.rowId;
        });
      });

      if (!contract || !contract.id || !contract.contractNo) {
        this.$message.error('缺少合同信息');
        return;
      } // 初始化回退表单


      this.rollbackForm = {
        orderId: order.rowId,
        orderNo: order.productionOrder,
        contractId: [contract.id],
        contractNo: contract.contractNo,
        custName: this.resolveCustName(contract, order),
        custAddress: this.resolveCustAddress(contract, order),
        orderDate: order.createTime ? order.createTime.slice(0, 10) : '',
        orderApprovalDate: '',
        plannedDeliveryDate: '',
        applyDate: new Date().toISOString().slice(0, 10),
        applyReason: '',
        productionOrder: order.productionOrder
      }; // 清空之前的附件

      this.rollbackFiles = [];

      if (this.$refs.rollbackFileUpload) {
        this.$refs.rollbackFileUpload.clearImgs();
      } // 打开回退弹窗


      this.showRollbackDialog = true;
    },
    // 保存订单回退
    saveRollback: function saveRollback() {
      var _this13 = this;

      // 表单验证
      if (!this.rollbackForm.contractId || !this.rollbackForm.contractNo || !this.rollbackForm.custName || !this.rollbackForm.custAddress || !this.rollbackForm.orderDate || !this.rollbackForm.orderApprovalDate || !this.rollbackForm.plannedDeliveryDate || !this.rollbackForm.applyDate || !this.rollbackForm.applyReason) {
        this.$message.error('请填写必填信息');
        return;
      } // 构建请求参数


      var params = {
        contractIds: this.rollbackForm.contractId,
        contractNo: this.rollbackForm.contractNo,
        custName: this.rollbackForm.custName,
        custAddress: this.rollbackForm.custAddress,
        orderDate: this.rollbackForm.orderDate,
        orderApprovalDate: this.rollbackForm.orderApprovalDate,
        plannedDeliveryDate: this.rollbackForm.plannedDeliveryDate,
        applyDate: this.rollbackForm.applyDate,
        applyReason: this.rollbackForm.applyReason,
        productionOrders: this.rollbackForm.productionOrder.split('、').map(function (order) {
          return order.trim();
        })
      }; // 只有当附件不为空时才添加到请求参数中

      if (this.rollbackFiles && this.rollbackFiles.length > 0) {
        params.files = this.rollbackFiles;
      } // 调用回退接口


      (0, _order.orderRollback)(params).then(function (response) {
        if (response.code === 200) {
          _this13.$message.success('回退成功');

          _this13.showRollbackDialog = false; // 刷新数据

          _this13.handleSearch(); // 清空附件


          _this13.rollbackFiles = [];

          if (_this13.$refs.rollbackFileUpload) {
            _this13.$refs.rollbackFileUpload.clearImgs();
          }
        } else {
          _this13.$message.error(response.msg || '回退失败');
        }
      }).catch(function (error) {
        console.error('回退失败:', error);

        _this13.$message.error('网络错误，请稍后重试');
      });
    },
    // 回退附件上传成功
    handleRollbackFileUpload: function handleRollbackFileUpload(filePaths) {
      var _this14 = this;

      this.rollbackFiles = [];
      filePaths.forEach(function (filePath) {
        try {
          var fileObj = JSON.parse(filePath);

          _this14.rollbackFiles.push(fileObj);
        } catch (e) {
          console.error('解析文件数据失败:', e);

          _this14.$message.error('解析文件数据失败，请重试');
        }
      });
    },
    // 回退附件删除成功
    handleRollbackFileDelete: function handleRollbackFileDelete(fileName) {
      this.rollbackFiles = this.rollbackFiles.filter(function (file) {
        return file.realName !== fileName;
      });
    },
    // 订单改单
    handleModifyOrder: function handleModifyOrder(order) {
      if (!order.rowId || !order.productionOrder) {
        this.$message.error('缺少订单信息');
        return;
      } // 查找当前订单所属的合同


      var contract = this.contractList.find(function (c) {
        return c.cmsCustDesignSchemeAuditList && c.cmsCustDesignSchemeAuditList.some(function (item) {
          return item.rowId === order.rowId;
        });
      });

      if (!contract || !contract.id) {
        this.$message.error('缺少合同信息');
        return;
      } // 打开改单弹窗


      this.currentModifyOrder = order;
      this.modifyOrderContractId = String(contract.id);
      this.modifyOrderContractNo = contract.contractNo || '';
      this.modifyOrderForm = {
        contractId: String(contract.id),
        serverUserName: '',
        serverNickName: '',
        questionType: '',
        problemDescription: ''
      };
      this.modifyOrderFiles = [];
      this.modifyOrderImages = [];
      this.modifyOrderVideos = [];
      this.showModifyOrderDialog = true;
    },
    // 改单提交 - 仅创建
    createChangeOnly: function createChangeOnly() {
      if (!this.modifyOrderForm.questionType) {
        this.$message.error('请选择问题类型');
        return;
      }

      this.doCreateChange(false);
    },
    // 改单提交 - 创建并下单
    createChangeAndOrder: function createChangeAndOrder() {
      if (!this.modifyOrderForm.questionType) {
        this.$message.error('请选择问题类型');
        return;
      }

      this.doCreateChange(true);
    },
    // 执行改单创建
    doCreateChange: function doCreateChange(withOrder) {
      var _this15 = this;

      (0, _contract2.addChangeContractAndAfter)({
        contractId: this.modifyOrderForm.contractId,
        file: this.modifyOrderFiles,
        image: this.modifyOrderImages,
        video: this.modifyOrderVideos,
        serverUserName: this.modifyOrderForm.serverUserName,
        serverNickName: this.modifyOrderForm.serverNickName,
        questionType: this.modifyOrderForm.questionType,
        problemDescription: this.modifyOrderForm.problemDescription
      }).then(function (response) {
        if (response.code === 200) {
          _this15.$message.success('改单成功');

          _this15.showModifyOrderDialog = false;

          if (withOrder) {
            var newContract = response.data;

            _this15.$router.push({
              path: '/orders/create',
              query: {
                contractId: newContract ? newContract.id : _this15.modifyOrderContractId,
                contractNo: newContract ? newContract.contractNo : _this15.modifyOrderContractNo,
                contractAmount: newContract ? newContract.amount || 0 : 0
              }
            });
          } else {
            _this15.handleSearch();
          }
        } else {
          _this15.$message.error(response.msg || '改单失败');
        }
      }).catch(function (error) {
        console.error('改单失败:', error);

        _this15.$message.error('网络错误，请稍后重试');
      });
    },
    // 改单附件上传成功
    handleModifyOrderFileUpload: function handleModifyOrderFileUpload(filePaths) {
      this.modifyOrderFiles = filePaths || [];
    },
    // 改单附件删除成功
    handleModifyOrderFileDelete: function handleModifyOrderFileDelete(filePaths) {
      this.modifyOrderFiles = filePaths || [];
    },
    // 改单图片上传成功
    handleModifyOrderImageUpload: function handleModifyOrderImageUpload(filePaths) {
      this.modifyOrderImages = filePaths || [];
    },
    // 改单图片删除成功
    handleModifyOrderImageDelete: function handleModifyOrderImageDelete(filePaths) {
      this.modifyOrderImages = filePaths || [];
    },
    // 改单视频上传成功
    handleModifyOrderVideoUpload: function handleModifyOrderVideoUpload(filePaths) {
      this.modifyOrderVideos = filePaths || [];
    },
    // 改单视频删除成功
    handleModifyOrderVideoDelete: function handleModifyOrderVideoDelete(filePaths) {
      this.modifyOrderVideos = filePaths || [];
    },
    // 打开客户选择
    openCustomerSelect: function openCustomerSelect() {
      this.customerSelectTarget = 'modify';
      this.showCustomerUserSelect = true;
      this.$refs.customerUserSelect.selectType = '客服';
    },
    // 客户选择关闭
    onCustomerUserSelectClose: function onCustomerUserSelectClose() {
      this.showCustomerUserSelect = false;
    },
    // 客户选择回调
    selectCustomerCallBack: function selectCustomerCallBack(user) {
      if (this.customerSelectTarget === 'addOrder') {
        this.addOrderForm.serverUserName = user.username || '';
        this.addOrderForm.serverNickName = user.nickName || '';
        this.showAddOrderCustomerSelect = false;
      } else {
        this.modifyOrderForm.serverUserName = user.username || '';
        this.modifyOrderForm.serverNickName = user.nickName || '';
      }

      this.showCustomerUserSelect = false;
    },
    // 订单补单
    handleAddOrder: function handleAddOrder(order) {
      var _this16 = this;

      if (!order.rowId || !order.productionOrder) {
        this.$message.error('缺少订单信息');
        return;
      } // 查找当前订单所属的合同


      var contract = this.contractList.find(function (c) {
        return c.cmsCustDesignSchemeAuditList && c.cmsCustDesignSchemeAuditList.some(function (item) {
          return item.rowId === order.rowId;
        });
      });
      this.addOrderContractId = contract ? String(contract.id) : '';
      this.addOrderContractNo = contract ? contract.contractNo || '' : '';
      this.addOrderForm.order = order;
      this.addOrderForm.reason = '';
      this.addOrderForm.bomList = [];
      this.addOrderForm.selectedBomList = [];
      this.addOrderForm.searchCode = '';
      this.addOrderForm.searchName = '';
      this.addOrderForm.searchColor = '';
      this.addOrderForm.searchBarCode = '';
      this.addOrderForm.searchMaterialTypeInfo = '';
      this.addOrderForm.searchLength = '';
      this.addOrderForm.searchWidth = '';
      this.addOrderForm.searchHeight = '';
      this.addOrderForm.searchQuantity = '';
      this.addOrderForm.searchRemark = '';
      this.addOrderForm.questionType = '';
      this.addOrderForm.serverUserName = '';
      this.addOrderForm.serverNickName = '';
      this.addOrderForm.problemDescription = '';
      this.addOrderFiles = [];
      this.addOrderImages = [];
      this.addOrderVideos = [];
      this.bomSearchVersion = 0; // 先显示弹窗，再设置加载状态

      this.showAddOrderDialog = true; // 延迟一下，确保弹窗DOM已渲染

      setTimeout(function () {
        _this16.bomTableLoading = true;
        (0, _order.getBomList)(order.productionOrder).then(function (response) {
          if (response && response.code === 200 && Array.isArray(response.data)) {
            _this16.addOrderForm.bomList = response.data;
          } else if (response && Array.isArray(response)) {
            _this16.addOrderForm.bomList = response;
          } else if (response && response.data && Array.isArray(response.data)) {
            _this16.addOrderForm.bomList = response.data;
          }
        }).catch(function (error) {
          console.error('获取BOM数据失败:', error);
        }).finally(function () {
          _this16.bomTableLoading = false;
        });
      }, 100);
    },
    // 补单 - 仅创建
    createReplenishmentOnly: function createReplenishmentOnly() {
      this.doReplenishment(false);
    },
    // 补单 - 创建并下单
    createReplenishmentAndOrder: function createReplenishmentAndOrder() {
      this.doReplenishment(true);
    },
    // 执行补单
    doReplenishment: function doReplenishment(withOrder) {
      var _this17 = this;

      if (!this.addOrderForm.questionType) {
        this.$message.error('请选择问题类型');
        return;
      }

      if (!this.addOrderForm.selectedBomList || this.addOrderForm.selectedBomList.length === 0) {
        this.$message.error('请选择要补单的BOM数据');
        return;
      }

      var auditId = this.addOrderForm.order.rowId;
      var list = this.addOrderForm.selectedBomList.map(function (item) {
        return {
          remark: item.remark || '',
          name: item.name || '',
          code: item.code || '',
          barcode: item.barcode || '',
          productCode: item.productCode || '',
          materialTypeInfo: item.material || '',
          color: item.color || '',
          length: item.length ? parseFloat(item.length) : 0,
          width: item.width ? parseFloat(item.width) : 0,
          height: item.height ? parseFloat(item.height) : 0,
          quantity: item.quantity ? parseInt(item.quantity) : 0,
          typeName: item.typeName || '',
          unit: item.unit || '',
          spec: item.spec || '',
          info1: item.info1 || '',
          info2: item.info2 || '',
          info3: item.info3 || '',
          info4: item.info4 || '',
          info5: item.info5 || '',
          info6: item.info6 || '',
          info7: item.info7 || '',
          info8: item.info8 || ''
        };
      });
      var data = {
        auditId: auditId,
        list: list,
        file: this.addOrderFiles,
        image: this.addOrderImages,
        video: this.addOrderVideos,
        serverUserName: this.addOrderForm.serverUserName,
        serverNickName: this.addOrderForm.serverNickName,
        questionType: this.addOrderForm.questionType,
        problemDescription: this.addOrderForm.problemDescription
      };
      (0, _order.orderReplenishmentCreate)(data).then(function (response) {
        if (response && response.code === 200) {
          _this17.$message.success('补单成功');

          _this17.showAddOrderDialog = false;

          if (withOrder) {
            var newContract = response.data;

            _this17.$router.push({
              path: '/orders/create',
              query: {
                contractId: newContract ? newContract.id : _this17.addOrderContractId,
                contractNo: newContract ? newContract.contractNo : _this17.addOrderContractNo,
                contractAmount: newContract ? newContract.amount || 0 : 0
              }
            });
          } else {
            _this17.handleSearch();
          }
        } else {
          _this17.$message.error(response.msg || '补单失败');
        }
      }).catch(function (error) {
        console.error('补单失败:', error);

        _this17.$message.error('补单失败');
      });
    },
    // 处理BOM表格选择
    handleBomSelectionChange: function handleBomSelectionChange(selection) {
      this.addOrderForm.selectedBomList = selection;
    },
    // 补单附件上传成功
    handleAddOrderFileUpload: function handleAddOrderFileUpload(filePaths) {
      this.addOrderFiles = filePaths || [];
    },
    // 补单附件删除成功
    handleAddOrderFileDelete: function handleAddOrderFileDelete(filePaths) {
      this.addOrderFiles = filePaths || [];
    },
    // 补单图片上传成功
    handleAddOrderImageUpload: function handleAddOrderImageUpload(filePaths) {
      this.addOrderImages = filePaths || [];
    },
    // 补单图片删除成功
    handleAddOrderImageDelete: function handleAddOrderImageDelete(filePaths) {
      this.addOrderImages = filePaths || [];
    },
    // 补单视频上传成功
    handleAddOrderVideoUpload: function handleAddOrderVideoUpload(filePaths) {
      this.addOrderVideos = filePaths || [];
    },
    // 补单视频删除成功
    handleAddOrderVideoDelete: function handleAddOrderVideoDelete(filePaths) {
      this.addOrderVideos = filePaths || [];
    },
    // 补单打开客户选择
    openAddOrderCustomerSelect: function openAddOrderCustomerSelect() {
      this.customerSelectTarget = 'addOrder';
      this.showAddOrderCustomerSelect = true;
      this.showCustomerUserSelect = true;
      this.$refs.customerUserSelect.selectType = '客服';
    },
    // 处理BOM表格行点击
    handleBomRowClick: function handleBomRowClick(row) {
      var table = this.$refs.bomTable;
      if (!table) return; // 触发展开/收起

      table.toggleRowExpansion(row);
    },
    // BOM表格搜索
    handleBomSearch: function handleBomSearch() {
      this.bomSearchVersion = Date.now();
    },
    // BOM表格重置搜索
    resetBomSearch: function resetBomSearch() {
      this.addOrderForm.searchCode = '';
      this.addOrderForm.searchName = '';
      this.addOrderForm.searchColor = '';
      this.addOrderForm.searchBarCode = '';
      this.addOrderForm.searchMaterialTypeInfo = '';
      this.addOrderForm.searchLength = '';
      this.addOrderForm.searchWidth = '';
      this.addOrderForm.searchHeight = '';
      this.addOrderForm.searchQuantity = '';
      this.addOrderForm.searchRemark = '';
      this.bomSearchVersion = Date.now();
    },
    // 批发货
    handleBatchShip: function handleBatchShip() {
      this.$message.info('批发货');
    },
    // 批量安装
    handleBatchInstall: function handleBatchInstall() {
      this.$message.info('批量安装');
    },
    // 查看报价
    handleViewQuotation: function handleViewQuotation(contract) {
      var _this18 = this;

      this.currentQuotationContract = contract;
      this.showQuotationDialog = true;
      this.$nextTick(function () {
        if (_this18.$refs.contractQuotationInfo) {
          _this18.$refs.contractQuotationInfo.init();
        }
      });
    },
    // 查看合同详情
    handleViewContract: function handleViewContract(contract) {
      this.currentContract = contract;

      try {
        var imgs = JSON.parse(contract.contractImgs || '[]');
        var imgPreviewPrefix = this.$store.getters.imgPreviewPrefix || '';
        this.contractViewImages = imgs.map(function (img) {
          return {
            url: "".concat(imgPreviewPrefix).concat(img.realName),
            name: img.realName
          };
        });
      } catch (e) {
        this.contractViewImages = [];
      }

      try {
        var files = JSON.parse(contract.file || '[]');
        var filePreviewPrefix = this.$store.getters.filePreviewPrefix || '';
        this.contractViewFiles = files.map(function (file) {
          return {
            url: file.url || "".concat(filePreviewPrefix).concat(file.realName),
            name: file.realName
          };
        });
      } catch (e) {
        this.contractViewFiles = [];
      }

      this.activeContractTab = 'design';
      this.showContractViewDialog = true;
    },
    // 点击合同号列打开合同详情
    handleColumnContractClick: function handleColumnContractClick(row) {
      // row 就是合同数据，直接调用
      this.handleViewContract(row);
    },
    // 合同详情Tab切换
    handleContractTabClick: function handleContractTabClick(tab) {
      if (tab.name === 'afterInfo') {
        if (this.$refs.contractAfterInfo) {
          this.$refs.contractAfterInfo.loadData();
        }
      }
    },
    // 预览图片
    previewImage: function previewImage(url) {
      this.previewImageUrl = url;
      this.previewImageVisible = true;
    },
    // 解析合同图片数据
    parseContractImgs: function parseContractImgs(contractImgs) {
      if (!contractImgs) {
        return [];
      }

      try {
        return JSON.parse(contractImgs);
      } catch (e) {
        return [];
      }
    },
    // 解析合同附件数据
    parseContractFiles: function parseContractFiles(fileData) {
      if (!fileData) {
        return [];
      }

      try {
        return JSON.parse(fileData);
      } catch (e) {
        return [];
      }
    },
    // 预览合同图片
    previewContractImgs: function previewContractImgs(contractImgs) {
      try {
        var imgs = JSON.parse(contractImgs);
        var imgPreviewPrefix = this.$store.getters.imgPreviewPrefix || '';
        this.previewImages = imgs.map(function (img) {
          return {
            url: "".concat(imgPreviewPrefix).concat(img.realName),
            name: img.alias || img.realName,
            alias: img.alias,
            realName: img.realName
          };
        });
        this.previewVisible = true;
      } catch (e) {}
    },
    // 下载图片
    handleDownload: function handleDownload(img) {
      var _this19 = this;

      var fileName = img.alias || img.name || img.localName || img.realName || 'image';
      (0, _cmsWorkOrder.downloadOssFile)({
        realName: img.realName || fileName,
        type: '图片'
      }).then(function (res) {
        var blobUrl = URL.createObjectURL(res);
        var link = document.createElement('a');
        link.href = blobUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(blobUrl);
      }).catch(function () {
        _this19.$message.error('下载失败，请重试');
      });
    },
    // 预览合同附件
    previewContractFiles: function previewContractFiles(fileData) {
      try {
        var files = JSON.parse(fileData);
        var filePreviewPrefix = this.$store.getters.filePreviewPrefix || '';
        this.previewFiles = files.map(function (file) {
          return {
            url: file.url || "".concat(filePreviewPrefix).concat(file.realName),
            name: file.alias || file.realName,
            alias: file.alias,
            realName: file.realName
          };
        });
        this.previewFilesVisible = true;
      } catch (e) {}
    },
    // 下载附件
    handleFileDownload: function handleFileDownload(file) {
      var _this20 = this;

      var fileName = file.alias || file.name || file.localName || file.realName || 'file'; // 通过 fetch + blob 下载，避免跨域 OSS 链接导致 a.download 不生效

      var doDownload = function doDownload(url) {
        fetch(url, {
          mode: 'cors'
        }).then(function (res) {
          return res.blob();
        }).then(function (blob) {
          var blobUrl = URL.createObjectURL(blob);
          var link = document.createElement('a');
          link.href = blobUrl;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(blobUrl);
        }).catch(function () {
          // 降级：直接跳转
          window.open(url, '_blank');
        });
      };

      if (file.url && file.url.startsWith('http')) {
        doDownload(file.url);
      } else {
        (0, _cmsWorkOrder.downloadOssFile)({
          realName: file.realName || fileName,
          type: '附件'
        }).then(function (res) {
          var blobUrl = URL.createObjectURL(res);
          var link = document.createElement('a');
          link.href = blobUrl;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(blobUrl);
        }).catch(function () {
          _this20.$message.error('下载失败，请重试');
        });
      }
    },
    // 在新窗口打开文件
    openFileInNewWindow: function openFileInNewWindow(url, realName) {
      try {
        var fileUrl = url;

        if (!fileUrl && realName) {
          var filePreviewPrefix = this.$store.getters.filePreviewPrefix || '';
          fileUrl = filePreviewPrefix + realName;
        }

        if (fileUrl) {
          window.open(fileUrl, '_blank');
        } else {
          this.$message.error('文件URL为空，无法打开');
        }
      } catch (e) {
        this.$message.error('打开失败，请重试');
      }
    },
    // 加急
    handleUrgent: function handleUrgent(contract) {
      var _this21 = this;

      // 打开加急申请弹窗
      // 只显示复选框选中的订单
      var selectedOrders = contract.cmsCustDesignSchemeAuditList.filter(function (item) {
        return _this21.checkedOrders.includes(item.rowId);
      });
      this.urgentApplyForm = {
        title: '',
        custName: this.resolveCustName(contract),
        applyDate: new Date().toISOString().slice(0, 10),
        applyReason: '',
        custAddress: this.resolveCustAddress(contract),
        remark: '',
        contractId: [contract.id],
        contractNo: contract.contractNo,
        orderNo: selectedOrders.map(function (item) {
          return item.productionOrder;
        }).join(', ')
      };
      this.showUrgentApplyDialog = true;
    },
    // 保存加急申请
    saveUrgentApply: function saveUrgentApply() {
      var _this22 = this;

      // 附件同步兜底：上传完成后组件未触发事件时也能正确识别
      if (!this.syncFilesFromUpload('urgentApplyFileUpload', 'handleFileUpload')) {
        return;
      } // 表单验证


      if (!this.urgentApplyForm.custName) {
        this.$message.error('客户名称不能为空');
        return;
      }

      if (!this.urgentApplyForm.applyDate) {
        this.$message.error('申请日期不能为空');
        return;
      }

      if (!this.urgentApplyForm.applyReason) {
        this.$message.error('申请原因不能为空');
        return;
      }

      if (!this.urgentApplyForm.custAddress) {
        this.$message.error('客户地址不能为空');
        return;
      } // 合并 urgentApplyFiles 中的文件与新上传的文件


      var uploadedFiles = []; // 首先添加 urgentApplyFiles 中的文件（已删除的文件不会在这个数组中）

      if (this.urgentApplyFiles && this.urgentApplyFiles.length > 0) {
        this.urgentApplyFiles.forEach(function (file) {
          uploadedFiles.push(file);
        });
      } // 然后添加新上传的文件


      if (this.$refs.urgentApplyFileUpload && this.$refs.urgentApplyFileUpload.filePaths) {
        this.$refs.urgentApplyFileUpload.filePaths.forEach(function (fileStr) {
          try {
            var fileObj = JSON.parse(fileStr); // 检查是否已存在相同的文件，避免重复添加

            var isDuplicate = uploadedFiles.some(function (existingFile) {
              return existingFile.realName === fileObj.realName;
            });

            if (!isDuplicate) {
              uploadedFiles.push(fileObj);
            }
          } catch (error) {
            console.error('解析文件数据失败:', error);
          }
        });
      } // 构建请求参数


      var params = {
        contractIds: this.urgentApplyForm.contractId,
        contractNo: this.urgentApplyForm.contractNo,
        applyType: '加急申请',
        applyDate: this.urgentApplyForm.applyDate,
        applyReason: this.urgentApplyForm.applyReason,
        custName: this.urgentApplyForm.custName,
        remark: this.urgentApplyForm.remark,
        custAddress: this.urgentApplyForm.custAddress,
        productionOrders: this.urgentApplyForm.orderNo.split('、').map(function (order) {
          return order.trim();
        })
      }; // 只有当附件不为空时才添加files参数

      if (uploadedFiles.length > 0) {
        params.files = uploadedFiles;
      } // 调用保存加急申请的接口


      (0, _contract2.addContractUrgentApply)(params).then(function (response) {
        if (response.code === 200) {
          // 提交成功后关闭弹窗
          _this22.$message.success('加急申请提交成功');

          _this22.showUrgentApplyDialog = false; // 刷新数据

          _this22.handleSearch(); // 更新合同的加急状态


          var contractIds = _this22.urgentApplyForm.contractId || [];

          _this22.contractList.forEach(function (contract) {
            if (contractIds.includes(contract.id)) {
              contract.isUrgent = true;
            }
          }); // 重置表单


          _this22.urgentApplyForm = {
            custName: '',
            applyDate: '',
            applyReason: '',
            custAddress: '',
            remark: ''
          };
          _this22.urgentApplyFiles = []; // 清空附件上传组件的文件列表

          if (_this22.$refs.urgentApplyFileUpload) {
            _this22.$refs.urgentApplyFileUpload.clearImgs();
          }
        } else {
          _this22.$message.error(response.msg || '加急申请提交失败');
        }
      }).catch(function (error) {
        console.error('加急申请提交失败:', error);

        _this22.$message.error('网络错误，请重试');
      });
    },
    // 处理附件上传成功
    handleFileUpload: function handleFileUpload(filePaths) {
      var _this23 = this;

      this.urgentApplyFiles = [];
      filePaths.forEach(function (filePath) {
        try {
          var fileObj = JSON.parse(filePath); // 检查图片格式是否为jpg或png

          if (fileObj.type === '图片') {
            var fileName = fileObj.realName.toLowerCase();

            if (!fileName.endsWith('.jpg') && !fileName.endsWith('.png')) {
              _this23.$message.error('图片只能上传jpg和png格式');

              return;
            }
          } // 直接将接口返回的数据包添加到 urgentApplyFiles 中


          _this23.urgentApplyFiles.push(fileObj);
        } catch (error) {
          console.error('解析文件数据失败:', error);
        }
      });
    },
    // 处理附件删除成功
    handleFileDelete: function handleFileDelete(fileName) {
      this.urgentApplyFiles = this.urgentApplyFiles.filter(function (file) {
        return file.realName !== fileName;
      });
    },
    // 处理批量付款附件上传成功
    handleBatchPayFileUpload: function handleBatchPayFileUpload(filePaths) {
      var _this24 = this;

      this.batchPayFiles = [];
      filePaths.forEach(function (filePath) {
        try {
          var fileObj = JSON.parse(filePath); // 检查图片格式是否为jpg或png

          if (fileObj.type === '图片') {
            var fileName = fileObj.realName.toLowerCase();

            if (!fileName.endsWith('.jpg') && !fileName.endsWith('.png')) {
              _this24.$message.error('图片只能上传jpg和png格式');

              return;
            }
          } // 检查是否已存在相同的文件，避免重复添加


          var isDuplicate = _this24.batchPayFiles.some(function (existingFile) {
            return existingFile.realName === fileObj.realName;
          });

          if (!isDuplicate) {
            _this24.batchPayFiles.push(fileObj);
          }
        } catch (error) {
          console.error('解析文件数据失败:', error);

          _this24.$message.error('解析文件数据失败，请重试');
        }
      });
    },
    // 处理批量付款附件删除成功
    handleBatchPayFileDelete: function handleBatchPayFileDelete(fileName) {
      this.batchPayFiles = this.batchPayFiles.filter(function (file) {
        return file.realName !== fileName;
      });
    },
    // 处理单个付款附件上传成功
    handlePayFileUpload: function handlePayFileUpload(filePaths) {
      var _this25 = this;

      this.payFiles = [];
      filePaths.forEach(function (filePath) {
        try {
          var fileObj = JSON.parse(filePath);

          _this25.payFiles.push(fileObj);
        } catch (e) {
          console.error('解析文件数据失败:', e);

          _this25.$message.error('解析文件数据失败，请重试');
        }
      });
    },
    // 处理单个付款附件删除成功
    handlePayFileDelete: function handlePayFileDelete(fileName) {
      this.payFiles = this.payFiles.filter(function (file) {
        return file.realName !== fileName;
      });
    },
    // 处理单个取消附件上传成功
    handleCancelFileUpload: function handleCancelFileUpload(filePaths) {
      var _this26 = this;

      this.cancelFiles = [];
      filePaths.forEach(function (filePath) {
        try {
          var fileObj = JSON.parse(filePath);

          _this26.cancelFiles.push(fileObj);
        } catch (e) {
          console.error('解析文件数据失败:', e);

          _this26.$message.error('解析文件数据失败，请重试');
        }
      });
    },
    // 处理单个取消附件删除成功
    handleCancelFileDelete: function handleCancelFileDelete(fileName) {
      this.cancelFiles = this.cancelFiles.filter(function (file) {
        return file.realName !== fileName;
      });
    },
    // 保存前同步上传组件中的文件（防止上传完成事件与保存点击存在时序差/事件丢失时误报“请上传附件”）
    syncFilesFromUpload: function syncFilesFromUpload(refName, handlerName) {
      var comp = this.$refs[refName];
      if (!comp) return true; // 附件还在上传中，提示稍候，避免以空列表提交

      if (comp.uploadingCount > 0) {
        this.$message.warning('附件正在上传中，请稍候再试');
        return false;
      } // 以组件内实际文件列表为准做兜底同步


      if (comp.filePaths && comp.filePaths.length > 0) {
        this[handlerName](comp.filePaths);
      }

      return true;
    },
    // 保存批量付款
    saveBatchPay: function saveBatchPay() {
      var _this27 = this;

      // 防止重复提交
      if (this.batchPaySubmitting) {
        return;
      } // 附件同步兜底：上传完成后组件未触发事件时也能正确识别


      if (!this.syncFilesFromUpload('batchPayFileUpload', 'handleBatchPayFileUpload')) {
        return;
      } // 表单验证


      if (!this.batchPayForm.payReason) {
        this.$message.error('付款事由不能为空');
        return;
      }

      if (!this.batchPayForm.totalAmount) {
        this.$message.error('总金额不能为空');
        return;
      }

      if (!this.batchPayForm.receivingAccount) {
        this.$message.error('收款账户不能为空');
        return;
      }

      if (this.batchPayFiles.length === 0) {
        this.$message.error('请上传付款附件');
        return;
      } // 构建请求参数


      var params = {
        contractIds: this.batchPayForm.contractIds,
        contractNo: this.batchPayForm.contractNo,
        productionOrders: this.batchPayForm.productionOrder.split('、').map(function (order) {
          return order.trim();
        }),
        payReason: this.batchPayForm.payReason,
        totalAmount: this.batchPayForm.totalAmount,
        receivingAccount: this.batchPayForm.receivingAccount,
        remark: this.batchPayForm.remark,
        files: this.batchPayFiles
      }; // 调用批量付款接口（提交中：按钮 loading + 全屏进行中提示）

      this.batchPaySubmitting = true;
      var submitLoading = this.$loading({
        lock: true,
        text: '正在提交付款，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      (0, _order.batchPaySales)(params).then(function (response) {
        if (response.code === 200) {
          _this27.$message.success('批量付款成功');

          _this27.showBatchPayDialog = false; // 刷新数据

          _this27.handleSearch(); // 清空选中


          _this27.checkedContracts = []; // 清空附件

          _this27.batchPayFiles = []; // 清空上传组件

          if (_this27.$refs.batchPayFileUpload) {
            _this27.$refs.batchPayFileUpload.clearImgs();
          }
        } else {
          _this27.$message.error(response.msg || '批量付款失败');
        }
      }).catch(function (error) {
        console.error('批量付款失败:', error);

        _this27.$message.error('网络错误，请稍后重试');
      }).finally(function () {
        _this27.batchPaySubmitting = false;
        submitLoading.close();
      });
    },
    // 保存单个订单付款
    savePay: function savePay() {
      var _this28 = this;

      // 防止重复提交
      if (this.paySubmitting) {
        return;
      } // 附件同步兜底：上传完成后组件未触发事件时也能正确识别


      if (!this.syncFilesFromUpload('payFileUpload', 'handlePayFileUpload')) {
        return;
      } // 表单验证


      if (!this.payForm.contractId) {
        this.$message.error('合同信息不能为空');
        return;
      }

      if (!this.payForm.contractNo) {
        this.$message.error('合同号不能为空');
        return;
      }

      if (!this.payForm.payReason) {
        this.$message.error('付款事由不能为空');
        return;
      }

      if (!this.payForm.totalAmount) {
        this.$message.error('总金额不能为空');
        return;
      }

      if (!this.payForm.receivingAccount) {
        this.$message.error('收款账户不能为空');
        return;
      }

      if (!this.payForm.productionOrder) {
        this.$message.error('销售单号不能为空');
        return;
      }

      if (this.payFiles.length === 0) {
        this.$message.error('请上传付款附件');
        return;
      } // 构建请求参数


      var params = {
        contractIds: this.payForm.contractId,
        contractNo: this.payForm.contractNo,
        remark: this.payForm.remark,
        productionOrders: this.payForm.productionOrder.split('、').map(function (order) {
          return order.trim();
        }),
        payReason: this.payForm.payReason,
        totalAmount: this.payForm.totalAmount,
        receivingAccount: this.payForm.receivingAccount
      }; // 只有当附件不为空时才添加到请求参数中

      if (this.payFiles && this.payFiles.length > 0) {
        params.files = this.payFiles;
      } // 调用付款接口（提交中：按钮 loading + 全屏进行中提示）


      this.paySubmitting = true;
      var submitLoading = this.$loading({
        lock: true,
        text: '正在提交付款，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      (0, _order.paySales)(params).then(function (response) {
        if (response.code === 200) {
          _this28.$message.success('付款成功');

          _this28.showPayDialog = false; // 刷新数据

          _this28.handleSearch(); // 清空附件


          _this28.payFiles = []; // 清空上传组件

          if (_this28.$refs.payFileUpload) {
            _this28.$refs.payFileUpload.clearImgs();
          }
        } else {
          _this28.$message.error(response.msg || '付款失败');
        }
      }).catch(function (error) {
        console.error('付款失败:', error);

        _this28.$message.error('网络错误，请稍后重试');
      }).finally(function () {
        _this28.paySubmitting = false;
        submitLoading.close();
      });
    },
    // 获取客户状态样式
    getCustomerStatusClass: function getCustomerStatusClass(status) {
      var statusMap = {
        '跟进中': 'el-tag--warning el-tag--mini el-tag--light',
        '已签单': 'el-tag--primary el-tag--mini el-tag--light',
        '已下单': 'el-tag--success el-tag--mini el-tag--light',
        '未下单': 'el-tag--info el-tag--mini el-tag--light',
        '待处理': 'el-tag--warning el-tag--mini el-tag--light',
        '已发货': 'el-tag--primary el-tag--mini el-tag--light',
        '已安装': 'el-tag--success el-tag--mini el-tag--light',
        '已完成': 'el-tag--success el-tag--mini el-tag--light',
        '售后中': 'el-tag--danger el-tag--mini el-tag--light'
      };
      return statusMap[status] || 'el-tag--info el-tag--mini el-tag--light';
    },
    // 全选
    handleAllCheck: function handleAllCheck(checked) {
      var _this29 = this;

      this.allChecked = checked;
      this.selectedContractIds = [];
      this.checkedContracts = [];
      this.checkedOrders = [];

      if (checked) {
        this.contractList.forEach(function (contract) {
          _this29.selectedContractIds.push(contract.id);

          _this29.checkedContracts.push(contract.id);

          if (contract.cmsCustDesignSchemeAuditList) {
            contract.cmsCustDesignSchemeAuditList.forEach(function (order) {
              _this29.checkedOrders.push(order.rowId);
            });
          }
        });
      }
    },
    // 合同复选框
    handleContractCheck: function handleContractCheck(contractId, checked) {
      var _this30 = this;

      if (checked) {
        this.selectedContractIds.push(contractId);
        this.checkedContracts.push(contractId);
        var contract = this.contractList.find(function (c) {
          return c.id === contractId;
        });

        if (contract && contract.cmsCustDesignSchemeAuditList) {
          contract.cmsCustDesignSchemeAuditList.forEach(function (order) {
            if (!_this30.checkedOrders.includes(order.rowId)) {
              _this30.checkedOrders.push(order.rowId);
            }
          });
        }
      } else {
        this.selectedContractIds = this.selectedContractIds.filter(function (id) {
          return id !== contractId;
        });
        this.checkedContracts = this.checkedContracts.filter(function (id) {
          return id !== contractId;
        });

        var _contract = this.contractList.find(function (c) {
          return c.id === contractId;
        });

        if (_contract && _contract.cmsCustDesignSchemeAuditList) {
          _contract.cmsCustDesignSchemeAuditList.forEach(function (order) {
            _this30.checkedOrders = _this30.checkedOrders.filter(function (id) {
              return id !== order.rowId;
            });
          });
        }
      }

      this.updateAllChecked();
    },
    // 更新全选状态
    updateAllChecked: function updateAllChecked() {
      var totalContracts = this.contractList.length;
      var checkedContractsCount = this.checkedContracts.length;
      var totalOrders = 0;
      var checkedOrdersCount = this.checkedOrders.length;
      this.contractList.forEach(function (contract) {
        if (contract.cmsCustDesignSchemeAuditList) {
          totalOrders += contract.cmsCustDesignSchemeAuditList.length;
        }
      });
      this.allChecked = checkedContractsCount === totalContracts && checkedOrdersCount === totalOrders;
    },
    // 订单复选框
    handleOrderCheck: function handleOrderCheck(orderId, checked) {
      if (checked) {
        if (!this.checkedOrders.includes(orderId)) {
          this.checkedOrders.push(orderId);
        }
      } else {
        this.checkedOrders = this.checkedOrders.filter(function (id) {
          return id !== orderId;
        });
      }

      this.updateAllChecked();
    },
    // 合同订单全选
    handleContractOrderCheck: function handleContractOrderCheck(contractId, checked) {
      var _this31 = this;

      var contract = this.contractList.find(function (c) {
        return c.id === contractId;
      });

      if (contract && contract.cmsCustDesignSchemeAuditList) {
        contract.cmsCustDesignSchemeAuditList.forEach(function (order) {
          if (checked) {
            if (!_this31.checkedOrders.includes(order.rowId)) {
              _this31.checkedOrders.push(order.rowId);
            }
          } else {
            _this31.checkedOrders = _this31.checkedOrders.filter(function (id) {
              return id !== order.rowId;
            });
          }
        });
      }

      this.updateAllChecked();
    },
    // 下单跳转合同方案
    handleCreateOrder: function handleCreateOrder(contract) {
      this.$router.push({
        path: '/orders/create',
        query: {
          contractId: contract.id,
          contractNo: contract.contractNo,
          contractAmount: contract.amount,
          originalContractNo: contract.originalContractNo || ''
        }
      });
    },
    handleReserveDateChange: function handleReserveDateChange(contract) {
      var _this32 = this;

      if (!contract.scheduledDeliveryDate) {
        return;
      }

      var dateStr = this.formatDate(contract.scheduledDeliveryDate);
      this.$confirm("\u786E\u8BA4\u5C06\u5408\u540C ".concat(contract.contractNo, " \u7684\u9884\u7EA6\u53D1\u8D27\u65F6\u95F4\u8BBE\u7F6E\u4E3A ").concat(dateStr, "\uFF1F"), '确认预约发货', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var loading = _this32.$loading({
          lock: true,
          text: '预约中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });

        var data = {
          contractNo: contract.contractNo,
          scheduledDeliveryDate: dateStr
        };
        (0, _send.reserveSend)(data).then(function (response) {
          loading.close();

          if (response.code === 200) {
            _this32.$message.success(response.message || '预约发货时间确认成功');
          } else {
            contract.scheduledDeliveryDate = null;

            _this32.$message.error(response.msg || '操作失败');
          }
        }).catch(function (error) {
          loading.close();
          contract.scheduledDeliveryDate = null;
          console.error('预约发货时间确认失败:', error);

          _this32.$message.error('网络错误，请稍后重试');
        });
      }).catch(function () {});
    },
    handleReserveInstallDateChange: function handleReserveInstallDateChange(row) {
      var _this33 = this;

      if (!row.reserveInstallDate) return;
      var dateStr = this.formatDate(row.reserveInstallDate);
      this.$confirm("\u786E\u8BA4\u5C06\u5408\u540C ".concat(row.contractNo, " \u7684\u9884\u7EA6\u5B89\u88C5\u65F6\u95F4\u8BBE\u7F6E\u4E3A ").concat(dateStr, "\uFF1F"), '确认预约安装', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var loading = _this33.$loading({
          lock: true,
          text: '预约中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });

        var data = {
          contractNo: row.contractNo,
          reserveInstallDate: dateStr
        };
        (0, _installTask.reserveInstallTask)(data).then(function (response) {
          loading.close();

          if (response.code === 200) {
            _this33.$message.success(response.message || '预约安装时间确认成功');
          } else {
            row.reserveInstallDate = null;

            _this33.$message.error(response.msg || '操作失败');
          }
        }).catch(function () {
          loading.close();
          row.reserveInstallDate = null;

          _this33.$message.error('网络错误，请稍后重试');
        });
      }).catch(function () {});
    },
    formatDate: function formatDate(date) {
      if (!date) return '';
      var d = new Date(date);
      var year = d.getFullYear();
      var month = String(d.getMonth() + 1).padStart(2, '0');
      var day = String(d.getDate()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day);
    },
    parseNickName: function parseNickName(val) {
      if (!val) return '';

      try {
        var arr = typeof val === 'string' ? JSON.parse(val) : val;
        if (Array.isArray(arr)) return arr.join('、');
        return val;
      } catch (e) {
        return val;
      }
    },
    // 获取合同状态样式
    getContractStatusClass: function getContractStatusClass(status) {
      var statusMap = {
        '进行中': 'el-tag--primary el-tag--mini el-tag--light',
        '已完成': 'el-tag--success el-tag--mini el-tag--light',
        '售后中': 'el-tag--warning el-tag--mini el-tag--light',
        '已关闭': 'el-tag--info el-tag--mini el-tag--light',
        '待签单': 'el-tag--warning el-tag--mini el-tag--light',
        '待下单': 'el-tag--warning el-tag--mini el-tag--light'
      };
      return statusMap[status] || 'el-tag--warning el-tag--mini el-tag--light';
    },
    // 处理状态按钮点击
    handleStatusClick: function handleStatusClick(status) {
      this.selectedStatus = status; // 关联搜索的合同状态

      if (status === '全部') {
        this.searchForm.contractStatus = '';
      } else {
        this.searchForm.contractStatus = status;
      } // 执行搜索


      this.handleSearch();
    },
    // 获取状态计数
    getStatusCount: function getStatusCount(label) {
      // 从字典中查找对应状态的unit
      var statusItem = this.dict.contract_status_button.find(function (item) {
        return item.label === label;
      });

      if (statusItem && statusItem.unit) {
        return this.statusCounts[statusItem.unit] || 0;
      }

      return 0;
    },
    // 获取标签类型
    getTagType: function getTagType(label) {
      var typeMap = {
        '待审核': 'info',
        '被退回': 'danger',
        '待付款': 'warning',
        '待入库': 'success',
        '齐套待预约': 'primary',
        '待发货': 'info',
        '不齐套发货': 'warning',
        '售后中': 'danger'
      };
      return typeMap[label] || 'primary';
    }
  }
};
exports.default = _default;